import { useCallback, useRef } from 'react';

/**
 * Хук для создания debounced функции
 * @param {Function} func - Функция для debounce
 * @param {number} delay - Задержка в миллисекундах
 * @returns {Function} Debounced функция
 */
export const useDebouncedCallback = (func, delay) => {
  const timeoutRef = useRef(null);

  return useCallback(
    (...args) => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }

      timeoutRef.current = setTimeout(() => {
        func(...args);
      }, delay);
    },
    [func, delay]
  );
};

export default useDebouncedCallback;
